<script setup lang="ts"></script>

<template>
  <v-footer app :class="$style.tableFooterBar" order="0">
    <slot></slot>
  </v-footer>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.tableFooterBar {
  height: variables.$tableFooterHeight;
  border-top: 1px solid colors.$color-brand-100;
  background-color: colors.$color-brand-50;
  padding: 0 variables.$pageMarginX;
}

@media print {
  .tableFooterBar {
    display: none;
  }
}
</style>
